import { type QuestionType } from 'types/services/Family'
import { type InconsistenciesType } from 'types/services/Inconsistencies'
import {
  incomeAllMembersRules,
  incomeRules,
} from 'utils/definitionRecomedationRules/incomeRules'
import handleFinalInfoCardAdjustments from 'utils/handleFinalInfoCardAdjustments'
import { isEmptyObject } from 'utils/utils'

/*
  🔵 Adiciona aos dados os atributos: isAlert, inconsistent. Onde os 
  alertas são calculados no front e as inconsistencias vem do back
*/

export function cardsInfosIncome(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  member: any,
  base: string
) {
  const cardsInfos: QuestionType[] = Object.keys(member.workAndIncome).map(
    (attribute: string) => {
      return {
        ...member.workAndIncome[attribute],
        isAlert: incomeRules(member, attribute, base),
      }
    }
  )

  return cardsInfos.sort((x: QuestionType, y: QuestionType) => {
    if (x.isAlert === y.isAlert) {
      return 0
    } else if (x.isAlert === true) {
      return -1
    }
    return 1
  })
}

export function cardsInfosAllMembersIncome(
  base: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  family: any,
  inconsistencies: InconsistenciesType | undefined | null
) {
  const cardsInfos: QuestionType[] = [
    !isEmptyObject(family?.workAndIncome?.lastMonthIncome) && {
      ...family.workAndIncome.lastMonthIncome,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('lastMonthIncome'),
    },
    !isEmptyObject(family?.summationLastMonthIncomePerMember) && {
      ...family.summationLastMonthIncomePerMember,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('lastMonthIncome'),
    },
    !isEmptyObject(family?.hasChildLabor) && {
      ...family.hasChildLabor,
      isAlert: incomeAllMembersRules(family, 'hasChildLabor', base),
    },
    !isEmptyObject(family?.workAndIncome?.familyMeanCapital) && {
      ...family.workAndIncome.familyMeanCapital,
      isAlert: false,
      inconsistent:
        inconsistencies?.workAndIncome?.includes('familyMeanCapital'),
    },
    !isEmptyObject(family?.workAndIncome?.totalExpense) && {
      ...family.workAndIncome.totalExpense,
      isAlert: incomeAllMembersRules(family, 'totalExpense', base),
      inconsistent: inconsistencies?.workAndIncome?.includes('totalExpense'),
    },
    !isEmptyObject(family?.workAndIncome?.waterExpense) && {
      ...family.workAndIncome.waterExpense,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('waterExpense'),
    },
    !isEmptyObject(family?.workAndIncome?.foodExpense) && {
      ...family.workAndIncome.foodExpense,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('foodExpense'),
    },
    !isEmptyObject(family?.workAndIncome?.remedyExpense) && {
      ...family.workAndIncome.remedyExpense,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('remedyExpense'),
    },
    !isEmptyObject(family?.workAndIncome?.gasExpense) && {
      ...family.workAndIncome.gasExpense,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('gasExpense'),
    },
    !isEmptyObject(family?.workAndIncome?.lightingExpense) && {
      ...family.workAndIncome.lightingExpense,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('lightingExpense'),
    },
    !isEmptyObject(family?.workAndIncome?.rentExpense) && {
      ...family.workAndIncome.rentExpense,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('rentExpense'),
    },
    !isEmptyObject(family?.workAndIncome?.transportExpense) && {
      ...family.workAndIncome.transportExpense,
      isAlert: false,
      inconsistent:
        inconsistencies?.workAndIncome?.includes('transportExpense'),
    },
    !isEmptyObject(family?.workAndIncome?.madeQualificationCourse) && {
      ...family.workAndIncome.madeQualificationCourse,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes(
        'madeQualificationCourse'
      ),
    },
    !isEmptyObject(family?.workAndIncome?.someoneWorks) && {
      ...family.workAndIncome.someoneWorks,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('someoneWorks'),
    },
    !isEmptyObject(family?.workAndIncome?.sourceOfIncome) && {
      ...family.workAndIncome.sourceOfIncome,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('sourceOfIncome'),
    },
    !isEmptyObject(family?.workAndIncome?.wantToMakeQualificationCourse) && {
      ...family.workAndIncome.wantToMakeQualificationCourse,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes(
        'wantToMakeQualificationCourse'
      ),
    },
    !isEmptyObject(family?.workAndIncome?.numberOfWorkers) && {
      ...family.workAndIncome.numberOfWorkers,
      isAlert: false,
      inconsistent: inconsistencies?.workAndIncome?.includes('numberOfWorkers'),
    },
  ].filter((card) => card)

  // função que confirma que um card não será alerta se for inconsistente e depois ordena os alertas para primeiro
  return handleFinalInfoCardAdjustments(cardsInfos)
}
